import React from 'react';
import PropTypes from 'prop-types';

export default function Exclamation(props) {
  var width = props.width,
      height = props.height,
      color = props.color;


  var path = '';

  for (var i = 0; i <= width; ++i) {
    path += 'M' + i + ' 0 L' + i + ' ' + (height - 2 * width) + ' ';
    path += 'M' + i + ' ' + (height - width) + ' L' + i + ' ' + height + ' ';
  }

  var style = { stroke: color, strokeWidth: '1px' };

  return React.createElement(
    'svg',
    { width: width, height: height, style: { shapeRendering: 'crispEdges' } },
    React.createElement('path', { d: path, style: style })
  );
}

Exclamation.displayName = 'Exclamation';
Exclamation.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired
};
Exclamation.defaultProps = {
  color: 'white'
};
//# sourceMappingURL=Exclamation.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/svg/Exclamation.js